import { render, staticRenderFns } from "./ConfigurationItems.vue?vue&type=template&id=4d58ba5b&"
import script from "./ConfigurationItems.js?vue&type=script&lang=js&"
export * from "./ConfigurationItems.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports